import { z } from "zod";

export const NotificationsResponseSchema = z.object({
  notifications: z.array(
    z.object({
      id: z.coerce.string(),
      type: z.string(),
      // The backend's ``NotificationConfigPublic`` deliberately redacts
      // ``webhook_url`` before serialization — it never appears on
      // ``GET /notification`` responses, so the FE schema must not
      // require it.
      config: z.object({
        name: z.string(),
      }),
    })
  ),
});
